/* eslint-disable no-console */
// This functionality is currently just a wrapper around console.error
// In the future, this could be extended to log errors remotely or other
// functionality such as interfacing with something like LogRocket
export default function logError(error: Error | string) {
  // check for a nock error (testing only)
  if (
    error instanceof Error &&
    error.message.match(/Nock: No match for request/)
  ) {
    console.error(error.stack);
    return;
  }
  console.error(error);
}

export class UnreachableCaseError extends Error {
  constructor(val: never) {
    super(`Unreachable case ${val}`);
  }
}

export class NotImplementedError extends Error {}
